// Отказы доступа обрабатывает глобальный пейвол, а не сообщение о сбое модели.
export function isAiAccessError(error) {
  const status = error.response?.status
  return (status === 403 || status === 429) && [
    'free_limit', 'token_limit', 'subscription_required',
    'guest_voice_limit', 'guest_recognition_limit',
  ].includes(error.response?.data?.error)
}

// The compatibility error code is not the reason: a legacy subscription_required
// may still mean the recognition/message counter was exhausted.
export function freeLimitContext(error) {
  if (!isAiAccessError(error)) return null
  const d = error.response.data
  if (d.error !== 'free_limit' && d.reason !== 'free_limit') return null
  const trigger = d.kind === 'msg' ? 'chat' : d.kind === 'analysis' ? 'analysis'
    : d.kind === 'rec' ? (d.trigger === 'voice' ? 'voice' : 'photo')
    : ['photo', 'voice', 'chat', 'analysis'].includes(d.trigger) ? d.trigger : 'photo'
  const context = { trigger }
  if (Number.isInteger(d.limit) && d.limit > 0) context.limit = d.limit
  if (Number.isInteger(d.used) && d.used >= 0) context.used = d.used
  return context
}

export function handleAiAccessError(error, auth) {
  if (!isAiAccessError(error)) return false
  const d = error.response.data
  const quota = freeLimitContext(error)
  if (quota) {
    // The server's reason and limit win over stale profile data and generic sheets.
    auth.showPaywall = false
    auth.showGuestLimit = false
    auth.showLimitPaywall = false
    auth.openFirstPaywall(quota.trigger, quota)
    void auth.checkAuthStatus()
  } else if (d.error === 'token_limit') {
    auth.updateTokenBudget({ used: d.used, limit: d.limit, pct: 100, remaining: 0 })
    auth.openTokenLimitPaywall()
  } else if (d.error === 'subscription_required') {
    auth.showPaywall = true
  } else if (d.error === 'guest_voice_limit') {
    auth.limitPaywallReason = 'guest_voice'
    auth.showLimitPaywall = true
  } else {
    auth.showGuestLimit = true
  }
  return true
}
